// extracted by mini-css-extract-plugin
export default {"videos_container":"Participant_videos_container__UEg7N","video":"Participant_video__8jbat","video_caption":"Participant_video_caption__GdgFD"};